// frontend/src/components/games/snake/SnakeBoard.tsx

import { FoodState, Point, SpecialItemState } from '../../../hooks/games/useSnakeGame';

interface SnakeBoardProps {
  gridSize: number;
  snake: Point[];
  food: FoodState;
  specialItem: SpecialItemState | null;
}

export function SnakeBoard({ gridSize, snake, food, specialItem }: SnakeBoardProps) {
  const cells: JSX.Element[] = [];

  for (let y = 0; y < gridSize; y++) {
    for (let x = 0; x < gridSize; x++) {
      const snakeIndex = snake.findIndex((seg) => seg.x === x && seg.y === y);
      const isHead = snakeIndex === 0;
      const isBody = snakeIndex > 0;
      const isFood = food.position.x === x && food.position.y === y;
      const isSpecial = !!specialItem && specialItem.position.x === x && specialItem.position.y === y;

      let content: string | null = null;
      let className = 'snake-cell';
      if (isHead) className += ' snake-head';
      else if (isBody) className += ' snake-body';

      if (isFood) content = food.emoji;
      if (isSpecial && specialItem) content = specialItem.config.emoji;

      cells.push(
        <div key={`${x}-${y}`} className={className}>
          {content && <span className="snake-cell-emoji">{content}</span>}
        </div>
      );
    }
  }

  return (
    <div
      className="snake-board"
      style={{ gridTemplateColumns: `repeat(${gridSize}, 1fr)`, gridTemplateRows: `repeat(${gridSize}, 1fr)` }}
    >
      {cells}
    </div>
  );
}
